import { FC } from "react"
import { Chip, ChipProps, Tooltip } from "@mui/material"
import { OSINT } from "../../interfaces"

const COLOR: Record<OSINT.Status, ChipProps["color"]> = {
  PENDING: "default",
  QUEUED: "default",
  SENT: "info",
  SEARCHING: "info",
  AWAITING_INPUT: "warning",
  COMPLETED: "success",
  FAILED: "error",
  TIMED_OUT: "warning",
}

const LABEL: Record<OSINT.Status, string> = {
  PENDING: "Ожидание",
  QUEUED: "В очереди",
  SENT: "Отправлен",
  SEARCHING: "Поиск",
  AWAITING_INPUT: "Требует действия",
  COMPLETED: "Готово",
  FAILED: "Ошибка",
  TIMED_OUT: "Таймаут",
}

interface IProps {
  status: OSINT.Status
  error?: string | null
}

export const StatusChip: FC<IProps> = ({ status, error }) => {
  const chip = (
    <Chip
      label={LABEL[status]}
      color={COLOR[status]}
      size="small"
      variant="outlined"
    />
  )
  if (error) {
    return <Tooltip title={error}>{chip}</Tooltip>
  }
  return chip
}
